<template>
  <div v-if="errors.length" class="error-alert">
    <div v-for="(err, i) in errors" :key="i" class="error-alert-message">
      {{ err.message }}
    </div>
  </div>
</template>
<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { useErrorsStore } from '@/store/ErrorsStore'

const errorsStore = useErrorsStore()
const { errors } = storeToRefs(errorsStore)
</script>
<style lang="scss" scoped>
@import '@/assets/styles/inc/variables';

.error-alert {
  padding: $spacer-3;
  margin-bottom: $spacer-3;
  background-color: rgba($red50, 0.1);
  border: 1px solid $red50;
  border-radius: $border-radius;
  color: $red50;
  font-size: $fs_1;
}

.error-alert-message {
  & + & {
    margin-top: $spacer-2;
  }
}
</style>
